import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clearWizardState, getWizardState, saveWizardState, updateWizardStep } from "./utils/wizardStorage";
import { Pages } from "..";
import { AccountStep, WelcomeStep } from "./wizardSteps/accountCreation";
import { NoAuthAccountLayout } from "../../layouts";

export const AccountSetup: React.FC = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState<number[]>([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const navigate = useNavigate();

    const steps = ["Welcome", "Account"];

    useEffect(() => {
        const savedState = getWizardState();
        setCurrentStep(savedState.currentStep);
        setCompletedSteps(savedState.completedSteps);
        setIsLoaded(true);
    }, []);

    useEffect(() => {
        if (isLoaded) {
            saveWizardState({
                currentStep,
                completedSteps,
            });
        }
    }, [currentStep, completedSteps, isLoaded]);

    const nextStep = () => {
        if (currentStep < steps.length - 1) {
            const newCompletedSteps = [...completedSteps, currentStep];
            const newCurrentStep = currentStep + 1;

            setCompletedSteps(newCompletedSteps);
            setCurrentStep(newCurrentStep);

            updateWizardStep(newCurrentStep);
        }
    };

    const prevStep = () => {
        if (currentStep > 0) {
            const newCurrentStep = currentStep - 1;
            setCurrentStep(newCurrentStep);
            updateWizardStep(newCurrentStep);
        }
    };

    const handleWizardAccountComplete = () => {
        clearWizardState();
        navigate(Pages.WizardSetupDevice.getUrl());
    };

    const handleWizardAccountCreate = () => {
        clearWizardState();
        navigate(Pages.WizardSetupTerms.getUrl());
    };

    const renderCurrentStep = () => {
        switch (currentStep) {
            case 0:
                return (
                    <div>
                        <WelcomeStep onNext={nextStep} />
                    </div>
                );
            case 1:
                return <AccountStep onNext={handleWizardAccountComplete} onCreate={handleWizardAccountCreate} onBack={prevStep} />;
            default:
                return <WelcomeStep onNext={nextStep} />;
        }
    };

    if (!isLoaded) {
        return (
            <NoAuthAccountLayout>
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p className="text-gray-600">Loading...</p>
                </div>
            </NoAuthAccountLayout>
        );
    }

    return (
        <NoAuthAccountLayout>
            <div className="container mx-auto py-8">
                <div className="max-w-4xl mx-auto">{renderCurrentStep()}</div>
            </div>
        </NoAuthAccountLayout>
    );
};
